import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

//Material UI Imports
import {
  Box,
  Chip,
  Typography,
} from '@mui/material';
import { useOrganizationSelect } from '../../../context/OrganizationSelectContext';

   


const VBO365Users = () => {

  const [VBO365Users, setVBO365Users] = useState([]);
    const { selectedOrganization } = useOrganizationSelect();
 
  const fetchVBO365Users = async () => {
      try {
            const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/vbo365/users`,
            {
              headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
              },
            }
            );
          let filteredData = response.data;
            if (selectedOrganization) {
            filteredData = response.data.filter(
              (item) => item.organizationDetails?.name === selectedOrganization
            );
            }
          setVBO365Users(filteredData);
      } catch (error) {
          console.error('Error fetching organizations:', error);
      }
  };

  

  useEffect(() => {
    fetchVBO365Users();
  }, [selectedOrganization]);

    const columns = useMemo(
      () => [
        {
          id: 'users',
          columns: [
            {
              accessorFn: (row) => row.name,
              id: 'name',
              header: 'Nom',
              size: 250,
              Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >{renderedCellValue}
                </Box>
              ),
              filterVariant: 'autocomplete',
            },
            {
              accessorFn: (row) => row.organizationDetails.name,
              id: 'organizationName',
              header: 'Client',
              size: 250,
              Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >
                  {renderedCellValue}
                </Box>
              ),
              filterVariant: 'autocomplete',
            },
            // {
            //   accessorFn: (row) => row.isBackup,
            //   id: 'isBackup',
            //   header: 'Sauvegardé',
            //   size: 10,
            //   Cell: ({ renderedCellValue, row }) => (
            //     <Box
            //       sx={{
            //         display: 'flex',
            //         alignItems: 'center',
            //         gap: '1rem',
            //       }}
            //     >
            //       {renderedCellValue === true ? (<CheckIcon/>) : (<ClearIcon/>)}
            //     </Box>
            //   ),
            //   filterVariant: 'autocomplete',
            // },
            {
              accessorFn: (row) => row.state,
              header: 'État',
              size: 40,
              Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >
                  <Chip
                    label={renderedCellValue}
                    color={
                      renderedCellValue === "New"
                        ? "success"
                        : renderedCellValue === "Licensed"
                        ? "primary"
                        : "error"
                    }
                  />
                </Box>
              ),
              filterVariant: 'autocomplete',
            },
            {
              accessorFn: (row) => new Date(row.lastBackupDate),
              id: 'lastBackupDate',
              header: 'Dernière Sauvegarde',
              size: 100,
              Cell: ({ renderedCellValue, row }) => {
                if (!renderedCellValue) return '';
                const date = new Date(renderedCellValue);
                const now = new Date();
                const diffMs = now - date;
                const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                const diffMinutes = Math.floor(diffMs / (1000 * 60));
                let display = '';
                if (diffDays > 0) {
                  display = `Il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
                } else if (diffHours > 0) {
                  display = `Il y a ${diffHours} heure${diffHours > 1 ? 's' : ''}`;
                } else if (diffMinutes > 0) {
                  display = `Il y a ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;
                } else {
                  display = "À l'instant";
                }
                return (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1rem',
                    }}
                  >
                    {display}
                  </Box>
                );
              },
              filterVariant: 'datetime-range',
            },
          ]
        }
      ],
      [],
    );
    
  
    const table = useMaterialReactTable({
      columns,
      data: VBO365Users ? VBO365Users : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
      enableColumnFilterModes: true,
      enableColumnOrdering: true,
      enableGrouping: true,
      enableColumnPinning: true,
      enableFacetedValues: true,
      initialState: {
        density:"compact",
        // showColumnFilters: true,
        // showGlobalFilter: true,
        columnPinning: {
          left: ['mrt-row-expand', 'mrt-row-select'],
          right: ['mrt-row-actions'],
        },
        pagination: {
          pageSize: 50,

        }
      },
      paginationDisplayMode: 'pages',
      positionToolbarAlertBanner: 'bottom',
      muiSearchTextFieldProps: {
        size: 'small',
        variant: 'outlined',
      },
      muiPaginationProps: {
        color: 'secondary',
        rowsPerPageOptions: [50, 100, 150],
        shape: 'rounded',
        variant: 'outlined',
      },
      // renderDetailPanel: ({ row }) => (
      //   <Box
      //     sx={{
      //       alignItems: 'center',
      //       display: 'flex',
      //       justifyContent: 'space-around',
      //       left: '30px',
      //       maxWidth: '1000px',
      //       position: 'sticky',
      //       width: '100%',
      //     }}
      //   >
      //     <Box sx={{ textAlign: 'center' }}>
      //       <Typography variant="h6">{row.original.accountName}</Typography>
      //       <Typography variant="h1">
      //       </Typography>
      //     </Box>
      //   </Box>
      // ),
    });
  
  
    return (
      <Box>
          <Typography variant="h6" my={1}>
            Utilisateurs Veeam Backup Office 365
            </Typography>
        <MaterialReactTable table={table} />
      </Box>
    );

};

export default VBO365Users;
